export const BIO = 9000;
export const PROJECT_DESCRIPTION = 1500;
export const EMPLOYMENT_DESCRIPTION = 9000;
export const EDUCATION_DESCRIPTION = 1000;